import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  content: "内容",
  fontFamily: "字体",
  fontSize: "字体大小",
  fontStyle: "字体样式",
  lineHeight: "行高",
  fontWeight: "字重",
  textAlign: "对齐方式",
  letterSpacing: "字间距",
  writingMode: "排列方式",
  color: "字体颜色",
  colorType: "字体颜色类型",
  startColor: "渐变色开始色值",
  endColor: "渐变色结束色值",
  textIsThemeColor: "字体颜色跟随主题色",
  textDecoration: "下划线",
  dateStyle: "日期格式",
  weekStyle: "星期格式"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
